export const AIRTABLE_STATUSES_FOR_CANCELLED = [
  "Processing",
  "Open",
  "Pending",
  "Complete",
];

export const AIRTABLE_STATUSES_FOR_FAILED = [
  "Processing",
  "Open",
  "Pending"
];
